import { Grid, Typography } from "@mui/material";
import SectionTitle from "../../components/landing/SectionTitle";
import { CONTACT_TITLE_TWO } from "../../utils/constants";
import ContactForm from "../../components/contact/ContactForm";

const Contact = () => (
  <>
    <Grid
      container
      className="p-x-landing bg-contact-section"
      justifyContent="center"
      paddingBottom={20}
      paddingTop={{ xs: 3, md: 14 }}
    >
      <SectionTitle title={CONTACT_TITLE_TWO} marginBottom={7} />
      <Typography className="w-100 f-s-24 m-t-10  m-b-20 text-center">
        Completá el siguiente formulario y nos pondremos en contacto a la
        brevedad.
      </Typography>
      <ContactForm />
    </Grid>
  </>
);
export default Contact;
